import apiClient from './client';

type ApiResponse<T> = {
  success: boolean;
  message: string;
  data?: T;
  errors?: unknown;
};

export type ApiKeyStatus = 'Active' | 'Paused' | 'Revoked';

export interface ApiKeyListItem {
  id: string;
  name: string;
  keyPrefix: string;
  status: ApiKeyStatus;
  requestsPerMinute: number;
  createdAt: string;
}

export interface ApiKeyCreatedResponse {
  id: string;
  churchId: string;
  name: string;
  keyPrefix: string;
  rawKey: string;
  status: ApiKeyStatus;
  requestsPerMinute: number;
  createdAt: string;
}

export const apiKeysApi = {
  async list(churchId: string): Promise<ApiKeyListItem[]> {
    const response = await apiClient.get<ApiResponse<ApiKeyListItem[]>>(`/api/churches/${churchId}/apikeys`);
    return response.data.data ?? [];
  },

  async generate(churchId: string, name: string): Promise<ApiKeyCreatedResponse> {
    const response = await apiClient.post<ApiResponse<ApiKeyCreatedResponse>>(`/api/churches/${churchId}/apikeys`, { name });
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || 'Failed to generate API key');
    }

    return response.data.data;
  },

  async pause(churchId: string, keyId: string): Promise<void> {
    await apiClient.put(`/api/churches/${churchId}/apikeys/${keyId}/pause`);
  },

  async resume(churchId: string, keyId: string): Promise<void> {
    await apiClient.put(`/api/churches/${churchId}/apikeys/${keyId}/resume`);
  },

  async revoke(churchId: string, keyId: string): Promise<void> {
    await apiClient.delete(`/api/churches/${churchId}/apikeys/${keyId}`);
  },
};
